module.exports = __webpack_public_path__ + "static/media/graph-grid.7d4ae8bb.svg";